/**
 * Shared constants for the excel-io feature.
 *
 * Keep this file dependency-free so it can be imported from anywhere
 * (lib, ui, tests).
 */

/** Hard cap on uploaded file size to prevent DOM/JS lockup on huge files. */
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024 // 10 MB

/** Hard cap on rows per sheet. Files exceeding this are rejected before validation. */
export const MAX_ROWS_PER_SHEET = 5_000

/** Maximum total data rows across all sheets (multiplier safety net). */
export const MAX_TOTAL_ROWS = 50_000

/**
 * Fields that are NEVER exposed as Excel columns in Phase 1.
 *
 * Two reasons to exclude:
 *   1) Coordinate / geometry data — out of scope per Plan §2.2.
 *   2) Relationship arrays — id-list fields are unsafe to edit by hand;
 *      Phase 2 will add a dedicated relationship importer.
 */
export const EXCLUDED_FIELD_KEYS: readonly string[] = [
  'position',
  'points',
  'width',
  'height',
  'boundingBox',
  'geometry',
  'relations',
]

/**
 * Returns true if a property key represents a relationship array
 * (e.g. `linkedParkingLocationIds`, `linkedEmergencyBellIds`).
 */
export function isRelationshipArrayKey(key: string): boolean {
  return key.startsWith('linked') && key.endsWith('Ids')
}

/** Accepted file extensions for Excel uploads. */
export const ACCEPTED_FILE_EXTENSIONS: readonly string[] = ['.xlsx', '.xls']

/** Default exported workbook filename pattern: `map-data-{mapName}-{YYYYMMDD-HHmm}.xlsx`. */
export const FILENAME_PREFIX = 'map-data'
export const FILENAME_TEMPLATE_PREFIX = 'map-template'
export const FILENAME_EXTENSION = 'xlsx'
